import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function ContactHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[420px] flex items-end pb-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/35dd7f30dba063213e60989d6f584843.jpg"
          alt="Limassol Cyprus"
          width={1440}
          height={420}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/50 to-slate-900/75"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32">
        <nav
          className={`flex items-center gap-2 text-sm text-white/60 mb-6 transition-all duration-500 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
        >
          <Link to="/" className="hover:text-amber-400 transition-colors">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white">Contact</span>
        </nav>

        <span
          className={`inline-block px-3 py-1 bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold uppercase tracking-widest rounded mb-4 transition-all duration-600 delay-100 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          Get In Touch
        </span>
        <h1
          className={`text-5xl sm:text-6xl lg:text-7xl font-semibold text-white leading-tight max-w-3xl transition-all duration-700 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          Contact CJ Solutions —<br />
          <span className="text-amber-400">Compliance &amp; Licensing</span><br />
          Consultants in Cyprus
        </h1>
        <p
          className={`mt-4 text-lg text-white/75 max-w-xl leading-relaxed transition-all duration-700 delay-[350ms] ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          Our team of experts in Limassol, Cyprus is ready to help you navigate regulatory, financial, and corporate challenges.
        </p>
      </div>
    </section>
  );
}
